/** @file keyedNodes: the nodes that have a key at the playhead frame of the open clip. */
import type { Clip } from '@zilo/pose3d-format/types/clip';

/** Node names keyed at exactly `frame` in `clip`; empty without a clip. */
export function keyedNodes(clip: Clip | undefined, frame: number): ReadonlySet<string> {
  const key = clip?.keys.find((k) => k.frame === frame);
  return new Set(key === undefined ? [] : Object.keys(key.nodes));
}
